import { render, staticRenderFns } from "./JVxeFileCell.vue?vue&type=template&id=025cd82c&scoped=true&"
import script from "./JVxeFileCell.vue?vue&type=script&lang=js&"
export * from "./JVxeFileCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025cd82c",
  null
  
)

export default component.exports